import request from '@/utils/request'

export const getProp = (params: any) =>
  request({
    method: 'get',
    url: '/api/props/getProp',
    params
  })
